import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import pages from '../routes';

const ChangePasswordRoute = ({ children }) => {
  const { data: user } = useSelector((state) => state.user);
  const userRoute = pages.find(
    (page) => page.roles.some(role => role === user?.roles) && page.groups.some(group => user?.userGroup.includes(group)),
  );

  if (!user) return <Navigate to="/" />;
  if (user && !user?.firstAccess)
    return (
      <Navigate to={`/dashboard/${userRoute?.path ? userRoute?.path : ''}`} />
    );
  if (user && user?.firstAccess) return children;
  return null;
};

export default ChangePasswordRoute;
